import { reflectKeys } from "@utils/key.reflactor";

export const NAMESPACE = {
  PRINT_VIEW: "print.view",
  APP: "app",
  AUTH: "auth",
};

export const LAC_STATUS = reflectKeys(["PROCESSING", "READY", "ERROR"]);

export const QUIZ_TEST_MODE = reflectKeys([
  "PRACTICE",
  "TEST_AUTO_RELEASE",
  "TEST_TEACHER_RELEASE",
]);
export type QuizTestMode = (typeof QUIZ_TEST_MODE)[keyof typeof QUIZ_TEST_MODE];
